import { defineMessages } from 'react-intl';

export default defineMessages({
  titleAlien: 'Edit Message',
  titleAuthor: 'Edit Your Post',
  returnLink: 'Return to {item}',
});
